import { render, staticRenderFns } from "./ComponentsPage.vue?vue&type=template&id=310b893c&scoped=true&"
import script from "./ComponentsPage.vue?vue&type=script&lang=ts&"
export * from "./ComponentsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentsPage.vue?vue&type=style&index=0&id=310b893c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310b893c",
  null
  
)

export default component.exports